import { useController } from 'react-hook-form';
import { default as Input } from '.';

export const InputTagController = (props) => {
    const { control, name, onChange, onBlur, onTagChange, ...rest } = props;
    const { field, fieldState } = useController({
        name,
        control,
    });

    return (
        <Input
            onChange={(value) => {
                const forwardedValue = !value ? null : value;
                onChange && onChange(forwardedValue);
            }}
            onTagChange={(value) => {
                const forwardedValue = !value ? null : value;
                onTagChange && onTagChange(forwardedValue);
                field.onChange(forwardedValue);
            }}
            onBlur={(...v) => {
                onBlur && onBlur(...v);
                field.onBlur(...v);
            }}
            value={field.value}
            name={field.name}
            inputState={fieldState.error ? 'errors' : fieldState}
            errorMessage={fieldState.error?.message}
            {...rest}
        />
    );
};
